module.exports = __webpack_public_path__ + "static/img/11areaA_01.302cd13.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/11areaA_01.png
// module id = 948
// module chunks = 1